<script lang="ts" setup>
const props = withDefaults(defineProps<{
  title?: string
  description?: string
  align?: 'left' | 'center' | 'responsive'
}>(), { align: 'center' })

const heroPattern = '/images/use-cases/hero-pattern.webp'

const alignClasses = {
  left: { justify: 'justify-center', text: 'text-left', description: 'mx-0' },
  center: { justify: 'justify-center', text: 'text-center', description: 'mx-auto' },
  responsive: { justify: 'justify-start md:justify-center', text: 'text-left md:text-center', description: 'mx-0 md:mx-auto' },
} as const

const alignClass = computed(() => alignClasses[props.align])
</script>

<template>
  <section
    data-el="SitePageHero"
    class="relative overflow-hidden border-b border-default"
  >
    <img
      :src="heroPattern"
      alt=""
      aria-hidden="true"
      class="pointer-events-none absolute inset-0 size-full object-cover"
    >
    <div class="relative z-10 px-5 py-20">
      <div class="mx-auto flex w-full max-w-350 font-display" :class="[alignClass.justify, alignClass.text]">
        <div class="flex max-w-215.5 flex-col gap-6">
          <h1 class="text-3xl font-normal text-primal md:text-5xl lg:text-7xl">
            <slot name="title">
              {{ title }}
            </slot>
          </h1>
          <slot name="description" :align-class="alignClass.description">
            <p v-if="description" class="w-2/3 text-base text-secondary" :class="alignClass.description">
              {{ description }}
            </p>
          </slot>
        </div>
      </div>
    </div>
  </section>
</template>
